import cn from 'classnames';

export const showIfTruthy = (condition = true) =>
  cn({ 'tw-hidden': !condition });
